import { Observable } from 'rxjs';
import _ from 'lodash';
import { ActionsObservable } from 'redux-observable';
import { Store } from 'redux';
import { initialize } from 'redux-form/immutable';
import { replace } from 'react-router-redux';

import { selectCauses } from 'entities/cause/selectors';
import CauseApi from 'entities/cause/api';
import Cause from 'entities/cause/model';
import { FORM_IDENTIFIER } from 'containers/CauseFormPage/constants';

import {
  INIT,
  ADD_NEW,
  initSuccessAction,
  initFailedAction,
  InitAction,
  AddNewAction,
} from './types';

const init = (action$: ActionsObservable<InitAction>, store: Store) =>
  action$.ofType(INIT).mergeMap(() => {
    const state = store.getState();
    const actions = [];
    const causes = selectCauses(state);

    if (causes.size === 0 || causes.first().nonprofits) {
      actions.push(CauseApi.fetchAll());
    }

    if (actions.length === 0) {
      return Observable.of(initSuccessAction());
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) =>
        Observable.concat(
          Observable.of(initSuccessAction()),
          Observable.of(..._.flatten(resultingActions))
        )
      )
      .catch((e) => Observable.of(initFailedAction(e)));
  });

const addNew = (action$: ActionsObservable<AddNewAction>) =>
  action$
    .ofType(ADD_NEW)
    .mergeMap(() => [initialize(FORM_IDENTIFIER, new Cause()), replace('/causes/edit/new')]);

export default [init, addNew];
